{
	"termsAndConditions": {
		"title": "Regulamin",
		"submitTitle": "Akceptuj i przejdź do Polityki prywatności"
	},
	"privacyPolicy": {
		"title": "Polityka prywatności",
		"submitTitle": "Akceptuj i zamknij",
		"backTitle": "Wstecz"
	}
}
